import { render, staticRenderFns } from "./detection-detail.vue?vue&type=template&id=b76b1ad4&"
import script from "./detection-detail.vue?vue&type=script&lang=js&"
export * from "./detection-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports